module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "toc-title"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_vm._v("Contents")])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/007_Preface#fm-1"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Preface02#fm-2"
    }
  }, [_vm._v("Preface to the Second Edition")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Intro#fm-3"
    }
  }, [_vm._v("Introduction: Images of a Heresy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Part01#pt-1"
    }
  }, [_vm._v("Part I Arius and the Nicene Crisis")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter01#ch-1"
    }
  }, [_vm._v("A Arius before Arianism")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter01#sec-1"
    }
  }, [_vm._v("1 Origins")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter01#sec-2"
    }
  }, [_vm._v("2 The Troubles of the Alexandrian Church I: The Melitian Schism")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter01#sec-3"
    }
  }, [_vm._v("3 The Troubles of the Alexandrian Church II: Bishops and Presbyters")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02#ch-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B The Nicene Crisis: Documents and Dating")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02#sec-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1 The Controversy to 325")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02#sec-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2 The "), _c('em', [_vm._v("Thalia")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter02#sec-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3 Nicaea and After")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter03#ch-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Part02#pt-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part II Arius and Theology")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter04#ch-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A The Theology of Arius")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter05#ch-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B Alexandria and the Legacy of Origen")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter05#sec-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1 Philo")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter05#sec-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2 Clement")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/016_Chapter05#sec-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3 Origen")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter05#sec-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4 Alexandria after Origen")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter06#ch-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C Theology Outside Egypt")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter06#sec-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1 Antioch")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter06#sec-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2 Methodius and Eusebius")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Chapter07#ch-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("D Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Part03#pt-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part III Arius and Philosophy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter08#ch-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Creation and Beginning")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/021_Chapter09#ch-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B Intellect and Beyond")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/022_Chapter10#ch-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C Analogy and Participation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/023_Chapter11#ch-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("D Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm1"
  }, [_c('span', {
    attrs: {
      "href": "#/024_Post#bm-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Postscript (Theological)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm"
  }, [_c('span', {
    attrs: {
      "href": "#/025_App01#bm-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix 1: Arius since 1987")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm"
  }, [_c('span', {
    attrs: {
      "href": "#/026_App02#bm-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix 2: Credal Documents")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm1"
  }, [_c('span', {
    attrs: {
      "href": "#/027_Endnotes#bm-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm"
  }, [_c('span', {
    attrs: {
      "href": "#/028_Abberviations#bm-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Abbreviations")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm"
  }, [_c('span', {
    attrs: {
      "href": "#/029_Bibliography#bm-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e6d147a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/006_Contents.vue
// module id = 72
// module chunks = 0